import * as types from './types';
import api from '~/services/api';
import { handleErrors } from '../common';

import { parseFloat, convertToUrlParameters } from '~/utils';

const contentVariableEndpoint = {
  url: '/quality/contentvariable',
  responseObject: 'content_variable',
  typeAction: types.SET_CONTENT_VARIABLES_LIST,
};

const buildContentVariableItems = (data, originalData) => data
  .filter(i => i.update_status)
  .map((d) => {
    const {
      element_id: element,
      element_point_id: subElement,
      analysis_type_id: analysisType,
      isDirty,
      end_date: endDate,
      end_time: endTime,
      id = 0,
      material_id: material,
      start_date: startDate,
      start_time: startTime,
      update_status: updateStatus,
      active,
    } = d;

    const contents = Object.keys(d)
      .filter(k => k.startsWith('content_'))
      .map((attrs) => {
        const [, contentId, valueType] = attrs.split('_');
        const valueTypeId = Number(valueType);
        if (updateStatus === 'U') {
          const { contents: originalContents = [] } = originalData.find(
            o => o.id === id,
          ) || {};
          const existingContentVariable = originalContents.find(
            c => c.content_id === Number(contentId),
          );
          if (existingContentVariable) {
            return {
              id: existingContentVariable.id,
              content_id: Number(contentId),
              value: valueTypeId === 0 ? parseFloat(d[attrs] || 0) : null,
              value_str: valueTypeId === 1 ? d[attrs] : null,
              update_status: 'U',
              active: existingContentVariable.active,
            };
          }
        }
        return {
          content_id: Number(contentId),
          value: valueTypeId === 0 ? parseFloat(d[attrs] || 0) : null,
          value_str: valueTypeId === 1 ? d[attrs] : null,
          update_status: 'I',
        };
      });
    return {
      element_id: element,
      element_point_id: subElement,
      isDirty,
      analysis_type_id: analysisType,
      end_date: endDate,
      end_time: endTime,
      id,
      material_id: material,
      start_date: startDate,
      start_time: startTime,
      update_status: updateStatus,
      active,
      contents,
    };
  });

export const getContentVariablesV2 = params => async (dispatch) => {
  const { startTimestamp, endTimestamp } = params;

  const queryString = `?${convertToUrlParameters({ startTimestamp, endTimestamp })}`;

  const {
    data: {
      result: { [contentVariableEndpoint.responseObject]: data = [] },
    },
  } = await api.get(`${contentVariableEndpoint.url}${queryString}`);

  dispatch({
    type: contentVariableEndpoint.typeAction,
    payload: data,
  });
};

export const updateContentVariablesV2 = (data, originalData, params) => async (dispatch) => {
  try {
    const items = buildContentVariableItems(data, originalData)
      .filter(d => d.update_status)
      .map(({
        isDirty, tableData, id, ...rest
      }) => {
        if (rest.update_status === 'U') return { id, ...rest };
        return rest;
      });
    const body = {
      [contentVariableEndpoint.responseObject]: items,
    };
    const { status } = await api.post(contentVariableEndpoint.url, body);
    if (status === 200) {
      dispatch(getContentVariablesV2(params));
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

const granulometryEndpointV2 = {
  url: '/v2/quality/granulometry',
  responseObject: 'granulometries',
  typeAction: types.SET_GRANULOMETRIES_LIST,
};

export const getGranulometriesV2 = (params = {}) => async (dispatch) => {
  try {
    const { start_date: startDate, end_date: endDate } = params;

    const queryParams = {};
    if (startDate) queryParams.start_date = startDate;
    if (endDate) queryParams.end_date = endDate;

    const queryString = Object.keys(queryParams).length
      ? `?${convertToUrlParameters(queryParams)}`
      : '';

    const {
      data: {
        result: { [granulometryEndpointV2.responseObject]: data = [] },
      },
    } = await api.get(`${granulometryEndpointV2.url}${queryString}`);

    dispatch({
      type: granulometryEndpointV2.typeAction,
      payload: data,
    });
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};
